import { TOKEN_VALID, TOKEN_ERROR } from "../../actions/types";

const initalizeState = {
    isAuthenticated: null
};

export default function(state = initalizeState, action) {
    const { type } = action;

    switch (type) {
        case TOKEN_VALID:
            return {
                ...state,
                isAuthenticated: true
            };
        case TOKEN_ERROR:
            return {
                ...state,
                isAuthenticated: false
            };
        default:
            return state;
    }
}
